import {CheckCircleOutlined, SendOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {useState} from 'react';
import {IoMdMail} from 'react-icons/io';
import {RiShoppingBagLine} from 'react-icons/ri';
import {Link} from 'react-router-dom';

import img1 from '../../assets/contactus.jpg.jpeg';

const {TextArea} = Input;

const ContactUsForm = () => {
  const [form] = Form.useForm();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [filledFields, setFilledFields] = useState({});

  const onFinish = values => {
    const {first_name, last_name, email, contact_no, message} = values;

    let whatsappMessage =
  'Hello, Kalapi Store , \n' +
  `I am ${first_name} ${last_name}\n` +
  `Contact: ${contact_no}\n` +
  `Message: ${message}`;
    if (email && email.trim() !== '') {
      whatsappMessage += `\nEmail: ${email}`;
    }

    const phoneNumber = '919125815116';
    const url =
      'https://wa.me/' +
      phoneNumber +
      '?text=' +
      encodeURIComponent(whatsappMessage);

    window.open(url, '_blank');
    setIsSubmitted(true);
    form.resetFields();
  };

  return (
    <div
      className={'min-h-screen w-full flex flex-col items-center md:px-0 px-4'}
    >
      <h1 className={'  md:text-4xl text-3xl my-6 mt-12 text-primary-900 flex font-semibold w-full justify-center items-center font-instrument '}>
         Contact Us
      </h1>
      <p className={'md:text-xl text-lg font-medium max-w-4xl text-center text-primary-800 mb-6'}>For any queries or exchange-related concerns, please fill out the form below. All requests are processed as per our policy and verification guidelines.</p>
      <div className={'w-full bg-primary-100 max-w-6xl border border-primary-200 justify-center items-center p-6 shadow-2xl rounded-xl grid grid-cols-1 lg:grid-cols-2 md:gap-0 gap-10'}>
        
        {/* LEFT SIDE – MAP */}
        <div className={'w-full h-[500px] lg:h-[550px] border-primary-300 rounded-xl overflow-hidden shadow-xl'}>
          <iframe
            title={'Google Map Location'}
            src={'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.582219554166!2d74.22469797396379!3d16.697776922307426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1000c9111176f%3A0xc0b9d1d96ba03b7b!2sKalapi%20Stores!5e0!3m2!1sen!2sin!4v1767089511189!5m2!1sen!2sin'}
            className={'w-full h-full border-0'}
            loading={'lazy'}
            referrerPolicy={'no-referrer-when-downgrade'}
          />
        </div>

        {/* RIGHT SIDE – FORM */}
        <div className={'flex justify-center items-center'}>
          <div className={'w-full max-w-md p-2 lg:p-8 '}>
            <h2 className={'Subtitle text-center'}>
              Send Us a Message
            </h2>

            {isSubmitted ? (
              <div className={'flex flex-col items-center mt-4 font-semibold text-primary-950'}>
                <CheckCircleOutlined className={'text-3xl text-green-400 mb-2'} />
                <div className={'text-center'}>
                  Thank you for your enquiry. We will get back to you soon....
                </div>
              </div>
            ) : (
              <Form
                form={form}
                name={'details'}
                onFinish={onFinish}
                className={'px-2 mt-4 py-4'}
              >
                <div className={'grid md:grid-cols-2 gap-6'}>

                  {/* First Name */}
                  <Form.Item name={'first_name'} rules={[{required: true, message: 'Enter First name'}]} className={'mb-0'}>
                    <div className={'relative w-full border-b-2 border-[#495057] focus-within:border-primary-800'}>
                      <Input
                        bordered={false}
                        value={form.getFieldValue('first_name')}
                        onFocus={() => setFocusedField('first_name')}
                        onBlur={e => {
                          setFocusedField(null);
                          setFilledFields(prev => ({...prev, first_name: e.target.value !== ''}));
                        }}
                        onChange={e => {
                          setFilledFields(prev => ({...prev, first_name: e.target.value !== ''}));
                        }}
                        className={'w-full bg-transparent text-base font-medium px-0 py-2.5'}
                      />
                      <label htmlFor={'first_name'} className={`absolute left-0 text-sm duration-300 origin-[0] ${focusedField === 'first_name' || filledFields.first_name  ? 'top-[-10px] scale-75 text-primary-800' : 'top-2 scale-100 text-[#212529]'}`}>
          First Name
                      </label>
                    </div>
                  </Form.Item>

                  {/* Last Name */}
                  <Form.Item name={'last_name'} rules={[{required: true, message: 'Enter last name'}]} className={'mb-0'}>
                    <div className={'relative w-full border-b-2 border-[#495057] focus-within:border-primary-800'}>
                      <Input
                        bordered={false}
                        value={form.getFieldValue('last_name')}
                        onFocus={() => setFocusedField('last_name')}
                        onBlur={e => {
                          setFocusedField(null);
                          setFilledFields(prev => ({...prev, last_name: e.target.value !== ''}));
                        }}
                        onChange={e => {
                          setFilledFields(prev => ({...prev, last_name: e.target.value !== ''}));
                        }}
                        className={'w-full text-base font-medium  bg-transparent px-0 py-2.5'}
                      />
                      <label htmlFor={'last_name'}  className={`absolute left-0 text-sm duration-300 origin-[0] ${focusedField === 'last_name' || filledFields.last_name ? 'top-[-10px] scale-75 text-primary-800'  : 'top-2 scale-100 text-[#212529]'}`}>
          Last Name
                      </label>
                    </div>
                  </Form.Item>

                </div>

                {/* Email */}
                <Form.Item name={'email'} rules={[{type: 'email', message: 'Invalid email format'}]} className={'mt-6 mb-0'}>
                  <div className={'relative w-full border-b-2 border-[#495057] focus-within:border-primary-800'}>
                    <Input
                      bordered={false}
                      value={form.getFieldValue('email')}
                      onFocus={() => setFocusedField('email')}
                      onBlur={e => {
                        setFocusedField(null);
                        setFilledFields(prev => ({...prev, email: e.target.value !== ''}));
                      }}
                      onChange={e => {
                        setFilledFields(prev => ({...prev, email: e.target.value !== ''}));
                      }}
                      className={'w-full text-base font-medium  bg-transparent px-0 py-2.5'}
                    />
                    <label htmlFor={'email'}  className={`absolute left-0 text-sm duration-300 origin-[0] ${focusedField === 'email' || filledFields.email ? 'top-[-10px] scale-75 text-primary-800' : 'top-2 scale-100 text-[#212529]'}`}>
        Email
                    </label>
                  </div>
                </Form.Item>

                {/* Contact */}
                <Form.Item
                  name={'contact_no'}
                  rules={[
                    {required: true, message: 'Enter contact number'},
                    {pattern: /^[0-9]{10}$/, message: 'Enter valid 10 digit number'},
                  ]}
                  className={'mt-6 mb-0'}
                >
                  <div className={'relative w-full border-b-2 border-[#495057] focus-within:border-primary-800'}>
                    <Input
                      bordered={false}
                      maxLength={10}
                      value={form.getFieldValue('contact_no')}
                      onFocus={() => setFocusedField('contact_no')}
                      onBlur={e => {
                        setFocusedField(null);
                        setFilledFields(prev => ({...prev, contact_no: e.target.value !== ''}));
                      }}
                      onChange={e => {
                        setFilledFields(prev => ({...prev, contact_no: e.target.value !== ''}));
                      }}
                      className={'w-full text-base font-medium  bg-transparent px-0 py-2.5'}
                    />
                    <label htmlFor={'contact_no'} className={`absolute left-0 text-sm duration-300 origin-[0] ${focusedField === 'contact_no' || filledFields.contact_no  ? 'top-[-10px] scale-75 text-primary-800'  : 'top-2 scale-100 text-[#212529]'}`}>
        Contact Number
                    </label>
                  </div>
                </Form.Item>

                {/* Message */}
                <Form.Item name={'message'} rules={[{required: true, message: 'Enter message'}]} className={'mt-6'}>
                  <div className={'relative w-full border-b-2 border-[#495057] focus-within:border-primary-800'}>
                    <Input.TextArea
                      bordered={false}
                      rows={3}
                      value={form.getFieldValue('message')}
                      onFocus={() => setFocusedField('message')}
                      onBlur={e => {
                        setFocusedField(null);
                        setFilledFields(prev => ({...prev, message: e.target.value !== ''}));
                      }}
                      onChange={e => {
                        setFilledFields(prev => ({...prev, message: e.target.value !== ''}));
                      }}
                      className={'w-full text-base font-medium  bg-transparent px-0 py-2.5 resize-none'}
                    />
                    <label htmlFor={'message'} className={`absolute left-0 pb-1 text-sm duration-300 origin-[0] ${focusedField === 'message' || filledFields.message ? 'top-[-10px] scale-75 text-primary-800' : 'top-2 scale-100 text-[#212529]'}`}>
        Message
                    </label>
                  </div>
                </Form.Item>

                {/* Button */}
                <Form.Item className={'mt-8 text-center'}>
                  <Button
                    type={'primary'}
                    htmlType={'submit'}
                    icon={<SendOutlined />}
                    className={'bg-primary-800 hover:!bg-primary-900 text-white px-6 py-2 rounded'}>
                  Send Message
                  </Button>
                </Form.Item>
              </Form>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactUsForm;
